import React from "react";
import CarTagView from "../../../../components/CarTag";
import { Box, Typography } from "@mui/material";
import profileImage from "../../../../../media/images/profileImage.png";
import bigCar2 from "../../../../../media/images/icons/bigcar2.svg";
export default function InfoBox() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "info.light",
        gap: "8px",
        paddingX: "14px",
        paddingY: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <img
            width={40}
            height={40}
            style={{
              borderRadius: "50%",
            }}
            src={profileImage}
            alt=""
          />
          <Typography
            sx={{
              color: "secondary.main",
            }}
          >
            رضا یعقوبی‌فریان پور
          </Typography>
        </Box>
        <CarTagView />
      </Box>
      <Box
        sx={{
          padding: "8px 8px",
          borderRadius: "8px",
          backgroundColor: "#F9FAFB",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <img src={bigCar2} alt="" />
          <Typography sx={{ fontWeight: "600" }}>نوع بارگیر:</Typography>
        </Box>
        <Typography
          sx={{
            fontWeight: "600",
            color: "secondary.main",
          }}
        >
          مسقف یا چادری خاور
        </Typography>
      </Box>
      <Box
        sx={{
          padding: "8px 8px",
          borderRadius: "8px",
          backgroundColor: "#F9FAFB",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <img src={bigCar2} alt="" />
          <Typography sx={{ fontWeight: "600" }}>گروه بارگیری</Typography>
        </Box>
        <Typography
          sx={{
            fontWeight: "600",
            color: "secondary.main",
          }}
        >
          مسقف یا چادری خاور
        </Typography>
      </Box>
    </Box>
  );
}
